import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" sx={{ fontSize: '120px', fontWeight: 'bold', margin: 0 }}>
          404
        </Typography>
        <Typography variant="h2" sx={{ fontSize: '32px', marginTop: '16px', marginBottom: '16px' }}>
          Page Not Found
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontSize: '16px', color: '#666', marginBottom: '32px', maxWidth: '500px' }}
        >
          Sorry, the page you are looking for does not exist. Please check the URL and try again.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
        >
          Go to Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
